import { render, staticRenderFns } from "./indicator-form.vue?vue&type=template&id=3842f033&scoped=true&"
import script from "./indicator-form.vue?vue&type=script&lang=ts&"
export * from "./indicator-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842f033",
  null
  
)

export default component.exports